module.exports = __webpack_public_path__ + "img/call-now.1bc54374.svg";